import React, { useEffect, useState } from "react";
import { Card, Button, Spinner, Dropdown, Badge } from "react-bootstrap";
import useIspettori from "../../hooks/useIspettori";
import CustomModal from "../../components/CustomModal/CustomModal";
import UserInfo from "../../components/UserInfo/UserInfo";
import IspettorePercorsoView from "../../components/IspettorePercorsoView/IspettorePercorsoView";

const AreaIspezionePage = () => {
  const {
    loadingIspettori,
    mieCorsi,
    corsistiByCorso,
    anagraficaCorsista,
    percorsoFormativo,
    downloadActivityReport,
  } = useIspettori();

  const [corsi, setCorsi] = useState([]);
  const [selectedCorso, setSelectedCorso] = useState(null);
  const [corsisti, setCorsisti] = useState([]);
  const [view, setView] = useState("corsi");
  const [selectedCorsista, setSelectedCorsista] = useState(null);
  const [anagrafica, setAnagrafica] = useState(null);
  const [percorso, setPercorso] = useState(null);
  const [showAnagrafica, setShowAnagrafica] = useState(false);

  useEffect(() => {
    (async () => {
      const list = await mieCorsi();
      setCorsi(Array.isArray(list) ? list : []);
    })();
  }, [mieCorsi]);

  const apriCorso = async (corso) => {
    setSelectedCorso(corso);
    setView("corsisti");
    const list = await corsistiByCorso(corso.id_corso);
    setCorsisti(Array.isArray(list) ? list : []);
  };

  const tornaCorsi = () => {
    setView("corsi");
    setSelectedCorso(null);
    setCorsisti([]);
    setSelectedCorsista(null);
    setPercorso(null);
  };

  const apriAnagrafica = async (corsista) => {
    const data = await anagraficaCorsista(selectedCorso.id_corso, corsista.id_utente);
    setAnagrafica(data);
    setShowAnagrafica(true);
  };

  const apriPercorso = async (corsista) => {
    setSelectedCorsista(corsista);
    setView("percorso");
    const data = await percorsoFormativo({
      id_corso: selectedCorso.id_corso,
      id_utente_corsista: corsista.id_utente,
      id_classe: corsista.id_classe,
      id_classe_utente: corsista.id_classe_utente,
    });
    setPercorso(data);
  };

  const scaricaReport = async (corsista) => {
    await downloadActivityReport(selectedCorso.id_corso, corsista.id_utente);
  };

  if (loadingIspettori.area && corsi.length === 0) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" />
      </div>
    );
  }

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between mb-4">
        <div>
          <h2 className="mb-1">Area ispezione</h2>
          <p className="text-muted mb-0">
            Verifica presenze, anagrafica corsisti e report attività sui corsi assegnati.
          </p>
        </div>
        {view !== "corsi" && (
          <Button variant="outline-secondary" onClick={view === "percorso" ? () => setView("corsisti") : tornaCorsi}>
            <i className="bi bi-arrow-left me-1" /> Indietro
          </Button>
        )}
      </div>

      {view === "corsi" && (
        <>
          {corsi.length === 0 ? (
            <Card className="border-0 shadow-sm">
              <Card.Body className="text-center py-5 text-muted">
                <i className="bi bi-journal-x fs-1 d-block mb-2" />
                Nessun corso assegnato. Contatta l'amministratore della piattaforma.
              </Card.Body>
            </Card>
          ) : (
            <div className="row g-3">
              {corsi.map((c) => (
                <div key={c.id_corso} className="col-12 col-md-6 col-lg-4">
                  <Card className="h-100 border-0 shadow-sm">
                    <Card.Body>
                      <Badge bg="info" className="mb-2">{c.ente_denominazione}</Badge>
                      <h5>{c.corso_titolo}</h5>
                      {c.corso_codice && <small className="text-muted d-block">Codice: {c.corso_codice}</small>}
                      <Button className="mt-3" variant="primary" onClick={() => apriCorso(c)}>
                        Ispeziona corsisti
                      </Button>
                    </Card.Body>
                  </Card>
                </div>
              ))}
            </div>
          )}
        </>
      )}

      {view === "corsisti" && selectedCorso && (
        <>
          <h4 className="mb-3">{selectedCorso.corso_titolo}</h4>
          {corsisti.length === 0 ? (
            <p className="text-muted">Nessun corsista iscritto a questo corso.</p>
          ) : (
            corsisti.map((u) => (
              <Card key={u.id_utente} className="mb-2 border-0 shadow-sm">
                <Card.Body className="d-flex flex-wrap justify-content-between align-items-center gap-2">
                  <div>
                    <strong>{u.nome} {u.cognome}</strong>
                    <div className="small text-muted">{u.username}</div>
                  </div>
                  <Dropdown align="end">
                    <Dropdown.Toggle variant="outline-primary" size="sm">Azioni ispezione</Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item onClick={() => apriPercorso(u)}>
                        <i className="bi bi-bar-chart-steps me-2" /> Percorso formativo / presenze
                      </Dropdown.Item>
                      <Dropdown.Item onClick={() => apriAnagrafica(u)}>
                        <i className="bi bi-person-lines-fill me-2" /> Anagrafica corsista
                      </Dropdown.Item>
                      <Dropdown.Item onClick={() => scaricaReport(u)} disabled={loadingIspettori.report}>
                        <i className="bi bi-file-earmark-pdf me-2" /> Scarica report attività
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </Card.Body>
              </Card>
            ))
          )}
        </>
      )}

      {view === "percorso" && selectedCorsista && (
        <IspettorePercorsoView
          percorso={percorso}
          nome={selectedCorsista.nome}
          cognome={selectedCorsista.cognome}
          loading={loadingIspettori.area}
        />
      )}

      <CustomModal
        show={showAnagrafica}
        onHide={() => setShowAnagrafica(false)}
        headerText="Anagrafica corsista"
        size="lg"
        body={anagrafica ? <UserInfo userData={anagrafica} /> : null}
        hideSaveBtn
      />
    </div>
  );
};

export default AreaIspezionePage;
